import script from "./ServicesHeaderPricesFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesHeaderPricesFilter.vue?vue&type=script&setup=true&lang=js"

import "./ServicesHeaderPricesFilter.vue?vue&type=style&index=0&id=474ce1ae&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474ce1ae"]])

export default __exports__